import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWandMagicSparkles } from "@fortawesome/free-solid-svg-icons";

const LoadingModal = ({ showSpinner, setShowSpinner, text = "" }) => {
  const { t } = useTranslation();
  const label = text || t("Backend.Modal.Loading");

  return (
    <Modal
      show={showSpinner}
      onHide={() => setShowSpinner && setShowSpinner(false)}
      centered
      backdrop="static"
      contentClassName="border-0"
      dialogClassName="loading-modal-dialog"
    >
      <Modal.Body style={{ padding: "40px 32px", textAlign: "center", borderRadius: 20, background: "#fff" }}>

        {/* Animated icon ring */}
        <div style={{ position: "relative", width: 72, height: 72, margin: "0 auto 24px" }}>
          {/* Spinning gradient ring */}
          <svg
            width="72" height="72"
            viewBox="0 0 72 72"
            style={{ position: "absolute", top: 0, left: 0, animation: "spin-ring 1.2s linear infinite" }}
          >
            <defs>
              <linearGradient id="ringGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" stopColor="#564ab1" />
                <stop offset="100%" stopColor="#038edc" stopOpacity="0" />
              </linearGradient>
            </defs>
            <circle
              cx="36" cy="36" r="30"
              fill="none"
              stroke="url(#ringGradient)"
              strokeWidth="3.5"
              strokeLinecap="round"
              strokeDasharray="120 60"
            />
          </svg>

          {/* Static background ring */}
          <svg width="72" height="72" viewBox="0 0 72 72" style={{ position: "absolute", top: 0, left: 0 }}>
            <circle cx="36" cy="36" r="30" fill="none" stroke="#eaecf0" strokeWidth="3.5" />
          </svg>

          {/* Center icon */}
          <div style={{
            position: "absolute", inset: 0,
            display: "flex", alignItems: "center", justifyContent: "center",
          }}>
            <div style={{
              width: 44, height: 44, borderRadius: "50%",
              background: "linear-gradient(135deg, rgba(86,74,177,0.1), rgba(3,142,220,0.1))",
              display: "flex", alignItems: "center", justifyContent: "center",
            }}>
              <FontAwesomeIcon
                icon={faWandMagicSparkles}
                style={{ fontSize: 18, color: "#564ab1" }}
              />
            </div>
          </div>
        </div>

        {/* Label */}
        <p style={{ margin: "0 0 6px", fontSize: 15, fontWeight: 700, color: "#111827" }}>
          {label}
        </p>
        <p style={{ margin: 0, fontSize: 12, color: "#9299a8" }}>
          {t("Backend.Modal.LoadingSubtext")}
        </p>

        {/* Animated dots */}
        <div style={{ display: "flex", justifyContent: "center", gap: 5, marginTop: 20 }}>
          {[0, 1, 2].map((i) => (
            <div key={i} style={{
              width: 6, height: 6, borderRadius: "50%",
              background: "linear-gradient(135deg, #564ab1, #038edc)",
              animation: `loading-dot 1.2s ease-in-out ${i * 0.2}s infinite`,
            }} />
          ))}
        </div>
      </Modal.Body>

      <style>{`
        @keyframes spin-ring {
          from { transform: rotate(0deg); }
          to   { transform: rotate(360deg); }
        }
        @keyframes loading-dot {
          0%, 80%, 100% { opacity: 0.2; transform: scale(0.8); }
          40%            { opacity: 1;   transform: scale(1.2); }
        }
        .loading-modal-dialog .modal-content {
          border-radius: 20px !important;
          box-shadow: 0 20px 60px rgba(0,0,0,0.12) !important;
          border: none !important;
          max-width: 300px;
          margin: auto;
        }
      `}</style>
    </Modal>
  );
};

export default LoadingModal;
